// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetGaugeOutput } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { GaugeForm, GaugeValues } from '@Organisms/Dashboard/WidgetManage/Gauge/GaugeForm';

export const getNewGaugeWidget = (gauge: GaugeValues): WidgetGaugeOutput => {
    const { title, entity, filters = [], periodDateField, safe, warning, critical } = gauge;

    return {
        type: WidgetChartTypeEnum.gauge,
        options: {
            title,
            entity,
            query: {},
            safe,
            warning,
            critical,
            periodDateField,
            filters,
        },
        id: '',
    };
};

const NewGaugeDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewGaugeWidget(values as GaugeValues)}
        WidgetForm={GaugeForm}
        widgetType="gauge"
    />
);

export default NewGaugeDrawer;
